import { render, staticRenderFns } from "./AdminSpareBrands.vue?vue&type=template&id=a3706658&scoped=true"
import script from "./AdminSpareBrands.vue?vue&type=script&lang=js"
export * from "./AdminSpareBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3706658",
  null
  
)

export default component.exports